/**
 * Units sold by measure (IS1-006): the till takes a decimal quantity, up to
 * 3 places, for these; pcs / box / pack stay whole numbers. Same list as the
 * API's billing/quantity-unit.ts, which refuses a fraction for any other unit.
 */
export const MEASURE_UNITS = ['kg', 'g', 'l', 'ml', 'm'] as const;

export function isMeasureUnit(unit: string | null | undefined): boolean {
  return (MEASURE_UNITS as readonly string[]).includes(String(unit ?? '').trim().toLowerCase());
}

/** A typed quantity for this unit: 3 decimals for a measure, whole otherwise. */
export function parseQuantityForUnit(raw: string, unit: string | null | undefined): number {
  const n = Number(raw);
  if (!Number.isFinite(n)) return 0;
  return isMeasureUnit(unit) ? Math.round(n * 1000) / 1000 : Math.floor(n);
}
